import { loader } from "graphql.macro";

export const CommentCreatedSubscription = loader(
  "./CommentCreatedSubscription.graphql"
);

export const CommentDeletedSubscription = loader(
  "./CommentDeletedSubscription.graphql"
);
